import { render, staticRenderFns } from "./ActiveReplenishment.vue?vue&type=template&id=3af6c833&scoped=true"
import script from "./ActiveReplenishment.vue?vue&type=script&lang=js"
export * from "./ActiveReplenishment.vue?vue&type=script&lang=js"
import style0 from "./ActiveReplenishment.vue?vue&type=style&index=0&id=3af6c833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6c833",
  null
  
)

export default component.exports